import growthbookPlugin from '@front/common/growthbook'
import Vue from 'vue'

Vue.use(growthbookPlugin)
